import { type ReactElement } from 'react'
import { type NotificationType } from '@terros/common'
import { ThemeIcon } from '@mantine/core'
import { type MaterialSymbolType } from '@front/model'
import { MaterialSymbolIcon } from '../components/terros/icon/MaterialSymbolIcon'

// ponytail: Event colors use defaults until the decorated API supplies the current stage color.
const actions: Record<NotificationType, { icon: MaterialSymbolType; color: string }> = {
  'area.assigned': { icon: 'person_add', color: '#059669' },
  'area.unassigned': { icon: 'remove', color: '#E11D48' },
  'accounts.assigned': { icon: 'pin_drop', color: '#059669' },
  'event.set': { icon: 'calendar_add_on', color: '#3877B4' },
  'event.cancelled': { icon: 'close', color: '#A3A3A3' },
  'event.rescheduled': { icon: 'update', color: '#3877B4' },
  'event.reassigned': { icon: 'sync_alt', color: '#3877B4' },
  'event.outcome': { icon: 'check', color: '#3877B4' },
  'event.dispatch': { icon: 'local_shipping', color: '#3877B4' },
  'event.closerUnavailable': { icon: 'person_off', color: '#E11D48' },
  'recording.flagged': { icon: 'flag', color: '#EA580C' },
  'meeting.nudge': { icon: 'back_hand', color: '#EA580C' },
  'meeting.reminder': { icon: 'notifications', color: '#D79F00' },
}

export function NotificationActionBadge({ type }: { type: NotificationType }): ReactElement {
  return (
    <ThemeIcon
      role='img'
      className='absolute -right-1 -bottom-1'
      radius='50%'
      color={actions[type].color}
      size={20}
      style={{ border: '2px solid var(--notification-row-surface, var(--mantine-color-body))' }}
      aria-label={type.replace('.', ' ')}
    >
      <MaterialSymbolIcon icon={actions[type].icon} size={13} />
    </ThemeIcon>
  )
}
